/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MaintenanceNotificationResponse = {
  id: number;
  puid: string;
  vin: string;
  sestCode: string;
  newRecordId: number;
  existRecordId: number;
  type: MaintenanceNotificationResponse.type;
  decisionType: MaintenanceNotificationResponse.decisionType;
  status: MaintenanceNotificationResponse.status;
  actionTaken: MaintenanceNotificationResponse.actionTaken;
  dataSource: MaintenanceNotificationResponse.dataSource;
  createdAt: string;
  updatedAt: string;
};
export namespace MaintenanceNotificationResponse {
  export enum type {
    NEW_RECORD = 'NEW_RECORD',
    KEEP_RECORD = 'KEEP_RECORD',
    COMPARISON = 'COMPARISON',
    INITIAL_NO_RECORD = 'INITIAL_NO_RECORD',
  }
  export enum decisionType {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC',
  }
  export enum status {
    UNREAD = 'UNREAD',
    READ = 'READ',
    PROCESSED = 'PROCESSED',
  }
  export enum actionTaken {
    KEEP_BOTH = 'KEEP_BOTH',
    KEEP_NEW_RECORD = 'KEEP_NEW_RECORD',
    KEEP_EXIST_RECORD = 'KEEP_EXIST_RECORD',
    PENDING_DECISION = 'PENDING_DECISION',
    RECORD_ADDED = 'RECORD_ADDED',
  }
  export enum dataSource {
    SERVICE_CENTER = 'SERVICE_CENTER',
    USER = 'USER',
    ADMIN = 'ADMIN',
  }
}

